module.exports = __webpack_public_path__ + "img/cry.b995adac.png";